import { QuestionTypeEnum } from '@/models/Question';
import { QuizCorrectionView } from '@/components/question/view/typologies/quiz/QuizCorrectionView';
import { OrderingCorrectionView } from '@/components/question/view/typologies/ordering/OrderingCorrectionView';
import { CombinationCorrectionView } from '@/components/question/view/typologies/combination/CombinationCorrectionView';
import { WritingCorrectionView } from '@/components/question/view/typologies/writing/WritingCorrectionView';
import { TrueOrFalseCorrectionView } from '@/components/question/view/typologies/trueOrFalse/TrueOrFalseCorrectionView';
import { QuizAnswerView } from '@/components/question/view/typologies/quiz/QuizAnswerView';
import { OrderingAnswerView } from '@/components/question/view/typologies/ordering/OrderingAnswerView';
import { CombinationAnswerView } from '@/components/question/view/typologies/combination/CombinationAnswerView';
import { WritingAnswerView } from '@/components/question/view/typologies/writing/WritingAnswerView';
import { TrueOrFalseAnswerView } from '../typologies/trueOrFalse/TrueOrFalseAnswerView';
import { FlashcardAnswerView } from '../typologies/flashcard/FlashcardAnswerView';
import { AnswerView, SupportedQuestionType } from '../types';
import { FillInTheBlankCorrectionView } from '../typologies/fill-in-the-blank/FillInTheBlankCorrectionView';
import { FillInTheBlankAnswerView } from '../typologies/fill-in-the-blank/FillInTheBlankAnswerView';

type ViewModeMap<T extends SupportedQuestionType> = {
  standard: AnswerView<T>;
  correction?: AnswerView<T>;
};

export type AnswerMap = { [T in SupportedQuestionType]?: ViewModeMap<T> };

export const answerMap: AnswerMap = {
  [QuestionTypeEnum.QUIZ]: {
    standard: QuizAnswerView,
    correction: QuizCorrectionView,
  },
  [QuestionTypeEnum.DND_ORDENATION]: {
    standard: OrderingAnswerView,
    correction: OrderingCorrectionView,
  },
  [QuestionTypeEnum.DND_POSITIONAL]: {
    standard: CombinationAnswerView,
    correction: CombinationCorrectionView,
  },
  [QuestionTypeEnum.WRITING]: {
    standard: WritingAnswerView,
    correction: WritingCorrectionView,
  },
  [QuestionTypeEnum.TRUE_OR_FALSE]: {
    standard: TrueOrFalseAnswerView,
    correction: TrueOrFalseCorrectionView,
  },
  [QuestionTypeEnum.FILL_IN_THE_BLANK]: {
    standard: FillInTheBlankAnswerView,
    correction: FillInTheBlankCorrectionView,
  },
  [QuestionTypeEnum.FLASHCARD]: {
    standard: FlashcardAnswerView,
  },
};
